<template>
    <div>
        <v-text-field
            v-bind:label="$t('Username')"
            v-model="digitalSignature.login"
            :error-messages="loginErrors"
            @input="validation.login.$touch()"
            @blur="validation.login.$touch()"
            autocomplete="off"
        ></v-text-field>
        <v-text-field
            v-bind:label="$t('ApiKey')"
            type="text"
            v-model="digitalSignature.password"
            :error-messages="passwordErrors"
            @input="apiKeyInput"
            @blur="validation.password.$touch()"
            autocomplete="off"
        ></v-text-field>
        <v-checkbox class="ma-0 pa-0"
            v-model="digitalSignature.isKeyEncrypted"
            v-bind:label="$t('Site.DigitalSignature.IsKeyEncrypted')"
        ></v-checkbox>
    </div>
</template>
<script>
export default {
    name: 'ConfigSkribbleSignatureForm',
    props: {
        digitalSignature: {
            type: Object,
            required: true
        },
        validation: {
            type: Object,
            required: true
        },
        loginErrors: {
            type: Array,
            default: () => []
        },
        passwordErrors: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        apiKeyInput() {
            this.validation.password.$touch();
            this.digitalSignature.isKeyEncrypted = false;
        }
    },
};
</script>